// import React, { useState } from 'react';
// import { ChevronLeft, ChevronRight, CheckCircle, Radio } from 'lucide-react';
// import blurTop from '../../assets/splashScreen/Blur.svg'
// import kyc from '../../assets/splashScreen/Group 714.svg'
// import { useNavigate } from 'react-router-dom';

// // Reusable component for the header
// const AppHeader = ({ title }) => (
//     <div className="flex items-center p-4 bg-white border-b border-gray-100">
//         <ChevronLeft className="w-6 h-6 text-gray-700" />
//         {/* <h1 className="flex-1 text-center text-lg font-semibold text-gray-800">{title}</h1> */}
//         <div className="w-6 h-6" /> {/* Placeholder for alignment */}
//     </div>
// );

// // Reusable component for a single document list item
// const DocumentItem = ({ title, status, isSelected, onClick }) => (
//     <div
//         className={`flex items-center justify-between p-4 my-2 rounded-xl transition-all duration-200 cursor-pointer ${
//             isSelected ? 'bg-indigo-50 border-indigo-200 border-2' : 'bg-white border border-gray-200'
//         }`}
//         onClick={onClick}
//     >
//         <div className="flex items-center">
//             {isSelected ? (
//                 <CheckCircle className="w-5 h-5 text-indigo-600 mr-4" fill="currentColor" />
//             ) : (
//                 <Radio className="w-5 h-5 text-gray-400 mr-4" />
//             )}
//             <span className="text-gray-800 font-medium">{title}</span>
//         </div>
//         <ChevronRight className="w-5 h-5 text-gray-400" />
//     </div>
// );

// // Main Screen Component
// const DocumentSelectionScreen = () => {
//     const [selectedDoc, setSelectedDoc] = useState('ID Card');

//     const documents = [
//         { title: 'ID Card', status: 'Pending' },
//         { title: 'Proof of ownership', status: 'Pending' },
//         { title: 'Site photo', status: 'Pending' },
//     ];

//     // Dummy navigation function (in a real app, this would use router)
//     const handleNext = () => {
//         alert(`Navigating to upload for: ${selectedDoc}`);
//     };

//     return (
//          <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden">
//    <AppHeader title="New Meter Application Form" />
//       {/* Decorative Blur Background */}
//       <img
//         src={blurTop}
//         alt="Decorative background blur"
//         className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-50 max-h-48 object-cover"
//       />

//       {/* Content Area */}
//       <div className="relative z-10 w-full max-w-sm mx-auto">
//       <div className="flex-1 flex justify-center items-center mt-4">
//           <img
//             src={kyc}
//             alt=""
//             className="w-full max-w-xs max-h-[45vh] object-contain"
//           />
//         </div>

//             <div className="flex-1 p-4 overflow-y-auto">
//                 <div className="bg-white p-5 rounded-xl shadow-lg">
//                     <h2 className="text-xl font-bold text-gray-900 mb-2">Documents upload</h2>
//                     <p className="text-sm text-gray-500 mb-6">
//                         Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.
//                     </p>

//                     {documents.map((doc) => (
//                         <DocumentItem
//                             key={doc.title}
//                             title={doc.title}
//                             status={doc.status}
//                             isSelected={selectedDoc === doc.title}
//                             onClick={() => setSelectedDoc(doc.title)}
//                         />
//                     ))}
//                 </div>
//             </div>

//             {/* <div className="p-4 bg-white border-t border-gray-100 shadow-xl">
//                 <button
//                     onClick={handleNext}
//                     className="w-full py-3 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transition-colors duration-200 shadow-lg shadow-indigo-500/50"
//                 >
//                     Save Draft and Continue
//                 </button>
//             </div> */}
//         </div>
//         </div>
//     );
// };

// export default DocumentSelectionScreen




// import React, { useState, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Upload, Pause, X, Radio, CheckCircle } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// // Reusable component for the header
// const AppHeader = ({ title }) => {
//     const navigate = useNavigate()
//     return (
//         <div className="flex items-center p-4 bg-white border-b border-gray-100 shadow-sm">
//             <ChevronLeft className="w-6 h-6 text-gray-700 cursor-pointer" onClick={() => {
//                 navigate('/kycid')
//             }} />
//             <h1 className="flex-1 text-center text-lg font-semibold text-gray-800">{title}</h1>
//             <div className="w-6 h-6" /> {/* Placeholder for alignment */}
//         </div>
//     )
// }

// // Component for the Progress Bar & Controls
// const UploadProgress = ({ progress, timeRemaining, onCancel }) => (
//     // Styling adjusted to match the compact look in the screenshot
//     <div className="mt-4 p-3 border border-gray-200 rounded-xl bg-white shadow-sm">
//         <div className="flex items-center justify-between text-sm font-medium mb-1">
//             <span className="text-gray-700">Uploading...</span>
//             <div className="flex items-center space-x-1">
//                 {/* 65% • 30 seconds remaining */}
//                 <span className="text-sm font-semibold text-gray-700">{Math.round(progress)}%</span>
//                 <span className="text-gray-400">•</span>
//                 <span className="text-sm text-gray-500">{Math.round(timeRemaining)} seconds remaining</span>
//             </div>
            
//             <div className="flex space-x-2 ml-4">
//                 <Pause className="w-5 h-5 text-gray-500 cursor-pointer hover:text-indigo-600" />
//                 <X className="w-5 h-5 text-red-500 cursor-pointer hover:text-red-700" onClick={onCancel} />
//             </div>
//         </div>
        
//         {/* Progress Bar */}
//         <div className="h-1.5 bg-gray-200 rounded-full">
//             <div
//                 className="h-full bg-indigo-600 rounded-full transition-all duration-500"
//                 style={{ width: `${progress}%` }}
//             ></div>
//         </div>
//     </div>
// );

// // Component for a single Document Selection Row
// const DocumentSelectionRow = ({ title, isSelected, onClick }) => (
//     <div
//         className={`flex items-center justify-between p-4 rounded-xl transition-colors duration-150 cursor-pointer 
//             ${isSelected ? 'bg-white' : 'bg-white hover:bg-gray-50'}`
//         }
//         onClick={onClick}
//     >
//         <div className="flex items-center">
//             {/* Custom Radio/Check Icon */}
//             <div className={`w-5 h-5 rounded-full border-2 mr-4 flex items-center justify-center ${
//                 isSelected ? 'border-indigo-600' : 'border-gray-400'
//             }`}>
//                 {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-indigo-600"></div>}
//             </div>
//             <span className={`font-medium ${isSelected ? 'text-gray-900' : 'text-gray-600'}`}>{title}</span>
//         </div>
//         <ChevronRight className="w-5 h-5 text-gray-400" />
//     </div>
// );

// // Component for the Drag & Drop Upload Area
// const DragDropArea = ({ onBrowseClick }) => (
//     // Styling adjusted to match the dashed border in the screenshot
//     <div className="p-6 border-2 border-dashed border-indigo-400 rounded-2xl bg-white text-center transition-all duration-300">
//         <div className="flex justify-center mb-3">
//             {/* Using a folder icon with an upload arrow to match the visual */}
//             <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-indigo-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
//                 <line x1="12" y1="10" x2="12" y2="16"></line>
//                 <polyline points="15 13 12 16 9 13"></polyline>
//             </svg>
//         </div>
//         <p className="text-gray-700 font-medium mb-1">Drag your file(s) to start uploading</p>
//         <p className="text-xs text-gray-500 mb-3">OR</p>
//         <button 
//             className="px-6 py-2 bg-white text-indigo-600 border border-indigo-600 font-semibold rounded-xl hover:bg-indigo-50 transition-colors duration-200 shadow-md text-sm"
//             onClick={onBrowseClick}
//         >
//             Browse files
//         </button>
//     </div>
// );

// // Main Screen Component
// const DocumentUploadScreen = () => {
//     const documents = [
//         { id: 'idCard', title: 'ID Card' },
//         { id: 'proofOfOwnership', title: 'Proof of ownership' },
//         { id: 'sitePhoto', title: 'Site photo' },
//     ];

//     const [activeDocumentId, setActiveDocumentId] = useState('idCard');
    
//     // State to track the upload stage for each document
//     // 'initial': DragDropArea is visible (selected) or nothing (unselected)
//     // 'uploading': DragDropArea and Progress bar are both visible
//     const [documentStages, setDocumentStages] = useState({
//         idCard: 'initial',
//         proofOfOwnership: 'initial',
//         sitePhoto: 'initial',
//     });

//     // Simulated progress state
//     const [simulatedProgress, setSimulatedProgress] = useState(0);
//     const [timeRemaining, setTimeRemaining] = useState(0);

//     // Effect to simulate uploading when a document is in the 'uploading' stage
//     useEffect(() => {
//         let progressInterval;

//         if (documentStages[activeDocumentId] === 'uploading' && simulatedProgress < 100) {
//             let progress = simulatedProgress;
//             let timer = 30 * (1 - progress / 100); // Remaining time based on progress
//             setTimeRemaining(timer);

//             progressInterval = setInterval(() => {
//                 progress += 5;
//                 timer -= 2.5;

//                 if (progress >= 100) {
//                     clearInterval(progressInterval);
//                     setSimulatedProgress(100);
//                     setTimeRemaining(0);
                    
//                     // Transition back to 'initial' after successful upload
//                     setDocumentStages(prev => ({
//                         ...prev,
//                         [activeDocumentId]: 'initial' 
//                     }));

//                 } else {
//                     setSimulatedProgress(progress);
//                     setTimeRemaining(Math.max(0, timer));
//                 }
//             }, 500); // Update every half second
//         }

//         return () => clearInterval(progressInterval);
//     }, [documentStages, activeDocumentId, simulatedProgress]);


//     const handleDocumentSelect = (docId) => {
//         setActiveDocumentId(docId);
//         // Ensure the stage is 'initial' when newly selected
//         setDocumentStages(prev => ({
//             ...prev,
//             [docId]: documentStages[docId] || 'initial' 
//         }));
//         setSimulatedProgress(0);
//     };

//     // Handler to simulate browsing/selecting a file, which starts the upload
//     const handleStartUpload = () => {
//         setDocumentStages(prev => ({
//             ...prev,
//             [activeDocumentId]: 'uploading'
//         }));
//         // Start simulation from a partial progress value if needed, matching the 65% visual
//         setSimulatedProgress(25); 
//     };

//     // Handler to cancel the upload
//     const handleCancelUpload = () => {
//         setDocumentStages(prev => ({
//             ...prev,
//             [activeDocumentId]: 'initial' // Go back to the browse state
//         }));
//         setSimulatedProgress(0);
//     };


//     return (
//         <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
//             <AppHeader title="New Meter Application Form" />

//             <div className="flex-1 p-4 overflow-y-auto">
//                 <div className="bg-white p-5 rounded-xl shadow-lg">
//                     <h2 className="text-xl font-bold text-gray-900 mb-2">Documents upload</h2>
//                     <p className="text-sm text-gray-500 mb-6">
//                         Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.
//                     </p>

//                     <div className="space-y-3">
//                         {documents.map((doc) => {
//                             const isSelected = doc.id === activeDocumentId;
//                             const currentStage = documentStages[doc.id];
                            
//                             return (
//                                 <React.Fragment key={doc.id}>
//                                     <DocumentSelectionRow
//                                         title={doc.title}
//                                         isSelected={isSelected}
//                                         onClick={() => handleDocumentSelect(doc.id)}
//                                     />
                                    
//                                     {/* Conditionally render the appropriate content below the selected row */}
//                                     {isSelected && (
//                                         <div className="px-4 pb-4">
//                                             {/* Drag & Drop Area is ALWAYS visible when a document is selected */}
//                                             <DragDropArea onBrowseClick={handleStartUpload} />
                                            
//                                             {/* Progress Bar is visible ONLY when the document is actively uploading */}
//                                             {currentStage === 'uploading' && (
//                                                 <UploadProgress
//                                                     progress={simulatedProgress}
//                                                     timeRemaining={Math.round(timeRemaining)}
//                                                     onCancel={handleCancelUpload}
//                                                 />
//                                             )}
//                                         </div>
//                                     )}
//                                 </React.Fragment>
//                             );
//                         })}
//                     </div>
//                 </div>
//             </div>

//             {/* Fixed Footer Buttons */}
//             <div className="p-4 bg-white border-t border-gray-100 shadow-xl space-y-3">
//                 <button
//                     className="w-full py-3 bg-white text-indigo-600 font-semibold rounded-xl border border-indigo-600 hover:bg-indigo-50 transition-colors duration-200"
//                     onClick={() => console.log('Saving draft...')}
//                 >
//                     Save Draft
//                 </button>
//                 <button
//                     className="w-full py-3 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transition-colors duration-200 shadow-lg shadow-indigo-500/50"
//                     onClick={() => console.log('Submitting application...')}
//                 >
//                     Submit Application
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default DocumentUploadScreen;



import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, CheckCircle, Radio, Pause, X } from 'lucide-react';
import docselect from '../../assets/splashScreen/Group 717.svg'
import { useNavigate } from 'react-router-dom';
// NOTE: Local imports for images (blurTop, kyc) are replaced with placeholder comments
// as external asset paths are not accessible in this environment.

// Reusable component for the header
const AppHeader = ({ title }) => {
const navigate = useNavigate()
    return(
    <div className="flex items-center p-4 bg-white border-b border-gray-100 shadow-sm sticky top-0 z-20">
        <ChevronLeft className="w-6 h-6 text-gray-700 cursor-pointer" onClick={()=>{
            navigate('/kycid')
        }}/>
        {/* The title is centered, as requested by the user */}
        <h1 className="flex-1 text-center text-lg font-semibold text-gray-800">{title}</h1>
        <div className="w-6 h-6" /> {/* Placeholder for alignment */}
    </div>
)}

// Component for the Progress Bar & Controls (Added upload simulation logic)
const UploadProgress = ({ progress, timeRemaining, onCancel }) => (
    <div className="mt-4 p-3 border border-gray-200 rounded-xl bg-white shadow-sm">
        <div className="flex items-center justify-between text-sm font-medium mb-1">
            <span className="text-gray-700">Uploading...</span>
            
            <div className="flex items-center space-x-4">
                <div className="flex items-center text-xs space-x-1">
                    <span className="font-semibold text-gray-700">{Math.round(progress)}%</span>
                    <span className="text-gray-400">•</span>
                    <span className="text-gray-500">{Math.round(timeRemaining)} seconds remaining</span>
                </div>
                
                <div className="flex space-x-2">
                    <Pause className="w-4 h-4 text-gray-500 cursor-pointer hover:text-indigo-600" />
                    <X className="w-4 h-4 text-red-500 cursor-pointer hover:text-red-700" onClick={onCancel} />
                </div>
            </div>
        </div>
        
        {/* Progress Bar */}
        <div className="h-1.5 bg-gray-200 rounded-full">
            <div
                className="h-full bg-indigo-600 rounded-full transition-all duration-500"
                style={{ width: `${progress}%` }}
            ></div>
        </div>
    </div>
);

// Component for the Drag & Drop Upload Area (The main action area)
const DragDropArea = ({ onBrowseClick }) => (
    <div className="mt-4 p-8 border-2 border-dashed border-indigo-400 rounded-2xl bg-white text-center transition-all duration-300">
        <div className="flex justify-center mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-indigo-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                <line x1="12" y1="10" x2="12" y2="16"></line>
                <polyline points="15 13 12 16 9 13"></polyline>
            </svg>
        </div>
        <p className="text-gray-700 font-medium mb-1">Drag your file(s) to start uploading</p>
        <p className="text-xs text-gray-500 mb-3">OR</p>
        <button 
            className="px-6 py-2 bg-white text-indigo-600 border border-indigo-600 font-semibold rounded-xl hover:bg-indigo-50 transition-colors duration-200 shadow-sm text-sm"
            onClick={onBrowseClick}
        >
            Browse files
        </button>
    </div>
);


// Reusable component for a single document list item (Adapted from user's code)
const DocumentItem = ({ doc, isSelected, onClick }) => (
    <div
        className={`flex flex-col rounded-xl transition-all duration-200 cursor-pointer 
            ${isSelected ? 'bg-white' : 'bg-white'}`
        }
    >
        <div 
            className={`flex items-center justify-between p-4 rounded-xl border-2 transition-all duration-200 ${
                isSelected ? 'bg-indigo-50 border-indigo-600' : 'border-gray-200 hover:border-indigo-400'
            }`}
            onClick={() => onClick(doc.id)}
        >
            <div className="flex items-center">
                {/* Retaining user's CheckCircle/Radio logic for selection display */}
                {isSelected ? (
                    <CheckCircle className="w-5 h-5 text-indigo-600 mr-4" fill="currentColor" />
                ) : (
                    <Radio className="w-5 h-5 text-gray-400 mr-4" />
                )}
                <span className="text-gray-800 font-medium">{doc.title}</span>
            </div>
            <ChevronRight className="w-5 h-5 text-gray-400" />
        </div>
    </div>
);


// Main Screen Component
const DocumentUploadScreen = () => {
    // Defined document structure with unique IDs
    const documents = [
        { id: 'idCard', title: 'ID Card', status: 'Pending' },
        { id: 'proofOfOwnership', title: 'Proof of ownership', status: 'Pending' },
        { id: 'sitePhoto', title: 'Site photo', status: 'Pending' },
    ];

    // State to track the currently selected document ID (null means no document is selected, showing the large image)
    const [activeDocumentId, setActiveDocumentId] = useState(null); 
    
    // State to track the upload stage for each document
    const [documentStages, setDocumentStages] = useState({
        idCard: 'initial', // 'initial', 'uploading', 'complete'
        proofOfOwnership: 'initial',
        sitePhoto: 'initial',
    });

    // Simulated progress state
    const [simulatedProgress, setSimulatedProgress] = useState(0);
    const [timeRemaining, setTimeRemaining] = useState(0);

    // Effect to simulate uploading when a document is in the 'uploading' stage
    useEffect(() => {
        let progressInterval;

        if (activeDocumentId && documentStages[activeDocumentId] === 'uploading' && simulatedProgress < 100) {
            let progress = simulatedProgress;
            let timer = 30 * (1 - progress / 100); 
            
            progressInterval = setInterval(() => {
                progress += 5;
                timer -= 2.5;

                if (progress >= 100) {
                    clearInterval(progressInterval);
                    setSimulatedProgress(100);
                    setTimeRemaining(0);
                    
                    // After completion, reset progress and set status to complete (optional)
                    setDocumentStages(prev => ({
                        ...prev,
                        [activeDocumentId]: 'initial' 
                    }));

                } else {
                    setSimulatedProgress(progress);
                    setTimeRemaining(Math.max(0, timer));
                }
            }, 500); 
        }

        return () => clearInterval(progressInterval);
    }, [documentStages, activeDocumentId, simulatedProgress]);


    const handleDocumentSelect = (docId) => {
        // Toggle selection logic: if clicking the current item, unselect it. Otherwise, select it.
        const newActiveId = activeDocumentId === docId ? null : docId;
        setActiveDocumentId(newActiveId);
        
        // Reset progress simulation when switching documents
        setSimulatedProgress(0);
        setTimeRemaining(0);
    };

    // Handler to simulate browsing/selecting a file, which starts the upload
    const handleStartUpload = () => {
        setDocumentStages(prev => ({
            ...prev,
            [activeDocumentId]: 'uploading'
        }));
        // Start simulation
        setSimulatedProgress(10); 
    };

    // Handler to cancel the upload
    const handleCancelUpload = () => {
        setDocumentStages(prev => ({
            ...prev,
            [activeDocumentId]: 'initial' // Go back to the browse state
        }));
        setSimulatedProgress(0);
    };


    // Check if any document is currently selected
    const isItemSelected = activeDocumentId !== null;

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
            <AppHeader title="New Meter Application Form" />

            <div className="flex-1 p-4 overflow-y-auto">
                
                {/* Decorative Blur and Image Area - HIDDEN when an item is selected */}
                {!isItemSelected && (
                    <div className="relative z-10 w-full mb-6">
                        {/* Decorative Blur Background (Using placeholder) */}
                        <div className="absolute top-0 left-0 w-full h-48 pointer-events-none select-none opacity-50 bg-indigo-100 rounded-b-xl" />
                        
                        {/* KYC Image (Using placeholder) */}
                        <div className="flex justify-center items-center mt-4 h-40">
                             {/* <div className="w-full max-w-xs h-full bg-indigo-200 rounded-xl flex items-center justify-center text-indigo-800 font-bold"> */}
                                 <img
            src={docselect}
            alt=""
            className="w-full max-w-xs max-h-[45vh] object-contain"
          />
                             {/* </div> */}
                        </div>
                    </div>
                )}
                
                <div className="bg-white p-5 rounded-xl shadow-lg relative z-10">
                    {/* Documents Upload Header */}
                    <h2 className="text-xl font-bold text-gray-900 mb-2">Documents upload</h2>
                    <p className="text-sm text-gray-500 mb-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.
                    </p>

                    <div className="space-y-4">
                        {documents.map((doc) => {
                            const isSelected = doc.id === activeDocumentId;
                            const currentStage = documentStages[doc.id];
                            
                            return (
                                <React.Fragment key={doc.id}>
                                    {/* Document Item Row */}
                                    <DocumentItem
                                        doc={doc}
                                        isSelected={isSelected}
                                        onClick={handleDocumentSelect}
                                    />
                                    
                                    {/* Upload/Browse Section - Only visible if the document is selected */}
                                    {isSelected && (
                                        <div className="px-1 pb-4 pt-1">
                                            {/* Drag & Drop Area is ALWAYS visible when a document is selected */}
                                            <DragDropArea onBrowseClick={handleStartUpload} />
                                            
                                            {/* Progress Bar is visible ONLY when the document is actively uploading */}
                                            {currentStage === 'uploading' && (
                                                <UploadProgress
                                                    progress={simulatedProgress}
                                                    timeRemaining={timeRemaining}
                                                    onCancel={handleCancelUpload}
                                                />
                                            )}
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Fixed Footer Buttons - Placed outside the scrollable area */}
            <div className="p-4 bg-white border-t border-gray-100 shadow-xl space-y-3 sticky bottom-0 z-20">
                <button
                    className="w-full py-3 bg-white text-indigo-600 font-semibold rounded-xl border border-indigo-600 hover:bg-indigo-50 transition-colors duration-200"
                    onClick={() => console.log('Saving draft...')}
                >
                    Save Draft
                </button>
                <button
                    className="w-full py-3 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transition-colors duration-200 shadow-lg shadow-indigo-500/50"
                    onClick={() => console.log('Submitting application...')}
                >
                    Submit Application
                </button>
            </div>
        </div>
    );
};

export default DocumentUploadScreen